import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp12};
`

export const OrderRow = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
  width: 100%;
  padding: ${props => props.theme.whiteLabel.spacing.sp16};
  background-color: ${props => props.theme.colors.grey.tone50};
  border: none;
  border-radius: ${props => props.theme.primitives.radius.radius3};
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: ${props => props.theme.colors.grey.tone100};
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export const OrderInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp4};
`

export const OrderHeading = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
`

export const OrderDate = styled(Text)`
  text-transform: uppercase;
`
